import { colors } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const headerStyles = StyleSheet.create({
  container: {
    backgroundColor: colors.maroon,
    borderRadius: 8,
    paddingVertical: 30,
    paddingHorizontal: 30,
  },
  bottomContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  branchHeader: {
    fontSize: 18,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    textAlign: "center",
    marginBottom: 20,
  },
  userText: {
    flex: 2,
    fontSize: 16,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
  logoutButtonContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  logoutButton: {
    paddingHorizontal: 35,
    paddingVertical: 15,
  },
});

export const aggregatorToggleStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 30,
  },
  modeText: {
    flex: 2,
    fontSize: 16,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
  toggleButtonContainer: {
    flex: 1,
    alignItems: "flex-end",
    marginRight: 40,
  },
});

export const printerInputStyles = StyleSheet.create({
  inputText: {
    color: colors.white,
    borderColor: colors.white,
    backgroundColor: colors.maroon,
  },
  inputLabelText: {
    color: colors.white,
  },
});

export const printerStyle = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  printerInputContainer: {
    flex: 2,
    marginVertical: 50,
  },
  testPrintButtonContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  testPrintButton: {
    paddingHorizontal: 35,
    paddingVertical: 15,
  },
});
